/**
 * React component for rendering a legend for a graph.
 * @param {Object} props - The props object containing weatherStations, dataGraphId, and selectedOptions.
 * @returns {JSX.Element} - The JSX element representing the graph legend.
 */
import React, { useState } from 'react';
import LegendModal from '@awp/components/dataTables/LegendModal';
import { OverlayTrigger, Popover, ListGroup } from 'react-bootstrap';

const GraphLegend = (props) => {
  const { weatherStations, dataGraphId, selectedOptions } = props;
  const [legend, setLegend] = useState([]);

  // Extract unique weather station IDs from selected options
  const selectedStations = selectedOptions.reduce((a, c) => {
    const v = c.weatherStationId;
    if (!a.includes(v)) {
      a.push(v);
    }
    return a;
  }, []);

  // Function to show legend modal
  const showLegend = (legendData) => {
    setLegend(legendData);
  };

  // Function to render a list item in the legend
  const renderListItem = (item, idx, legendData) => {
    const legendItemColor = legendData ? (
      <OverlayTrigger
        key={`${item.value}_${idx}`}
        placement="bottom"
        overlay={
          <Popover id={`popover_${item.value}`}>
            <Popover.Content>
              <p className="text-left m-0 p-0">Click to see legend</p>
            </Popover.Content>
          </Popover>
        }
      >
        <span
          className="multistation_legend__item__color"
          style={{
            background: item.color,
            borderColor: item.color,
          }}
          onClick={() => showLegend(legendData)}
        ></span>
      </OverlayTrigger>
    ) : (
      <span
        className="multistation_legend__item__color"
        style={{
          background: item.color,
          borderColor: item.color,
        }}
      ></span>
    );

    return (
      <ListGroup.Item key={`${item.value}`} className="multistation_legend__item">
        <span className="multistation_legend__item__container">{legendItemColor}</span>
        <span
          className="multistation_legend__item__text"
          style={{ display: 'inline-block' }}
        >{`${item.label} (${item.group})`}</span>
      </ListGroup.Item>
    );
  };

  return (
    <>
      {/* Render legend for each selected weather station */}
      {selectedStations.map((wxId, idx) => {
        const stationInfo = weatherStations.find((ws) => ws.Id === wxId);
        // Check if stationInfo exists before rendering
        return stationInfo ? (
          <div key={`${stationInfo.Id}_${idx}`}>
            <p
              className="multistation_legend__station"
              style={{ fontWeight: 'bold' }}
            >{`${stationInfo.Name} (${stationInfo.Number})`}</p>
            <ListGroup variant="flush" id={dataGraphId + '_LegendList'} className="multistation_legend__list">
              {/* Render legend items for the current weather station */}
              {selectedOptions
                .filter((o) => o.weatherStationId === wxId)
                .map((dataset, idx) => renderListItem(dataset, idx, false))}
            </ListGroup>
          </div>
        ) : null;
      })}
      {/* Render legend modal */}
      <LegendModal legend={legend} setLegend={setLegend} />
    </>
  );
};

export default GraphLegend;
